import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { switchMap, map, catchError, of } from "rxjs";
import { MarketingAutomationClient } from "src/api-service";
import { normalizeError } from "../../../../app-store-error.types";
import { InactiveCustomersActions } from "./inactive-customers.actions";
import { environment } from "@env/environment";

@Injectable()
export class InactiveCustomersEffects {
    private readonly actions$ = inject(Actions);
    private readonly marketingAutomationClient = inject(MarketingAutomationClient);

    loadInactiveCustomers$ = createEffect(() =>
        this.actions$.pipe(
            ofType(InactiveCustomersActions.load),
            switchMap(() =>
                this.marketingAutomationClient.getInactiveCustomers({
                    companyId: environment.InactiveCustomersBCCompanyId,
                    environment: environment.InactiveCustomersBCEnvironment
                }).pipe(
                    map(customers => InactiveCustomersActions.loadSuccess({ customers })),
                    catchError(error =>
                        of(
                            InactiveCustomersActions.loadFailure({
                                error: normalizeError(error),
                                toastKey: "DEVELOPER.MARKETING_REMINDERS.LOAD_ERROR",
                            }),
                        ),
                    ),
                ),
            ),
        ),
    );
}
